import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { combineLatest, Observable } from "rxjs";
import { filter, tap } from "rxjs/operators";

import { CoreState } from "../../state";
import { DgaAuthTransactionAction } from "../dga/dga-auth-transaction.action";
import { DgaAuthTransactionSelector } from "../dga/dga-auth-transaction.selector";

@Injectable()
export class ExperianService {
	constructor(
		private store: Store<CoreState>,
		private dgaAuthTransactionSelector: DgaAuthTransactionSelector,
		private dgaAuthTransactionAction: DgaAuthTransactionAction
	) {}

	getExperianData$(): Observable<any> {
		return combineLatest([
			this.store.select(this.dgaAuthTransactionSelector.getAuthenticationToken()),
			this.store.select(this.dgaAuthTransactionSelector.getCpr()),
		]).pipe(
			filter(([token, cpr]) => !!token && !!cpr),
			tap(([token]) => this.store.dispatch(this.dgaAuthTransactionAction.getExperianData({ token })))
		);
	}
}
